import ObservationsHeadingValidations, {
  ObservationsHeadingValidationsContext,
} from './ObservationsHeadingValidations'

export { ObservationsHeadingValidationsContext }
export default ObservationsHeadingValidations
